// All user-facing strings live here so a non-technical reviewer can audit the
// whole surface in one file without hunting through templates.
//
// Copy principles: no jargon, one action per screen, skip always visible.

export const copy = {
  intro: {
    title: "Let's find your Wi-Fi gear",
    body:
      "For each box on your home network, turn it over and take a photo of the sticker on the back or bottom. That's where the model number and other details we need are printed. About two minutes. You can skip anything you're not sure about.",
    heroSrc: '/assets/examples/intro-hero.jpg',
    heroAlt:
      'Diagram: router and gateway, a label with barcode and details, a phone photographing the sticker.',
    start: "Get started",
  },

  modem: {
    title: "The box from your internet company",
    body:
      "Usually near where the cable or phone line comes into your house. Turn it around and photograph the sticker on the back or bottom, where the model number, serial, and other details are printed.",
    stickerHint:
      "Point the camera at the printed label, not the front of the box.",
    exampleLabel: "Here's a good photo of one",
    exampleCaption: "AT&T BGW320-500: back plate, label fills the frame.",
    take: "Take a photo of the sticker",
    usePhoto: "Use this photo",
    retake: "Retake",
    continue: "Continue",
    skip: "I can't find it",
  },

  gateway: {
    title: "Your main Wi-Fi router",
    body:
      "The box your Wi-Fi comes from. Turn it around and photograph the sticker on the back or bottom, where the model number, serial, and other details are printed. If your internet company's box is also your Wi-Fi, you can skip this step.",
    stickerHint:
      "Point the camera at the printed label, not the front of the box.",
    exampleLabel: "Here's a good photo of one",
    exampleCaption: "Tenda AC6: bottom plate, label clear and centered.",
    take: "Take a photo of the sticker",
    usePhoto: "Use this photo",
    retake: "Retake",
    continue: "Continue",
    skip: "Same as the last one",
  },

  ap: {
    title: "More Wi-Fi boxes around the house",
    body:
      "Extra boxes that help Wi-Fi reach rooms far from the main router. Turn each one over and photograph the sticker on the back or bottom, then tell us which room it's in.",
    stickerHint:
      "Point the camera at the printed label, not the front of the box.",
    exampleLabel: "Here's a good photo of one",
    exampleCaption: "Same idea: flip the box, snap the printed sticker.",
    take: "Take a photo of the sticker",
    usePhoto: "Use this photo",
    retake: "Retake",
    roomLabel: "Which room is this in?",
    roomPlaceholder: "Living room, office, garage…",
    add: "Add this one",
    done: "That's all of them",
    skip: "I don't have any",
  },

  done: {
    title: "All set, nice work",
    body:
      "Head back to your Mac. It'll update with what we found on your network.",
    summaryLabel: "What you photographed",
  },

  result: {
    recognizedTitle: "Sweet, got it",
    recognizedHint: "If that looks right, hit continue. If not, retake.",
    unrecognizedTitle: "Hmm, couldn't read that one",
    unrecognizedHint:
      "Try again with steadier hands or more light. Fill the frame with the sticker so the text is easy to read.",
    fieldVendor: "Brand",
    fieldModel: "Model",
    fieldHardware: "Hardware version",
    fieldSerial: "Serial",
    fieldMac: "MAC",
    fieldSsid: "Wi-Fi name",
  },

  uploading: "Reading the label…",
  uploadError: "Couldn't send that photo. Try again?",
  sessionMissing:
    "This link is missing or has expired. Open the Field Trip again from your Mac to get a fresh link.",
};
